import { isTransportOrder, type OrderSummary } from '#domain/Order.ts';

export type CapacityMetric = 'weight' | 'loadingMeter' | 'liter' | 'cubicMeter';

type Kilogram = number;
type Tonne = number;

export const capacityMetrics: CapacityMetric[] = ['weight', 'loadingMeter', 'liter', 'cubicMeter'];

// Weight limits and load totals are compared at gram precision.
export const normalizeWeightKg = (weight: Kilogram): Kilogram => Number(weight.toFixed(3));

export const toCapacityWeightKg = (weight: Tonne | undefined): Kilogram | undefined =>
    weight === undefined ? undefined : normalizeWeightKg(weight * 1000);

export const getRelevantCapacityMetrics = (orders: OrderSummary[]): Set<CapacityMetric> => {
    if (orders.length === 0) {
        return new Set(capacityMetrics);
    }

    const result = new Set<CapacityMetric>();
    for (const order of orders) {
        if (!isTransportOrder(order)) {
            continue;
        }

        for (const material of order.materials ?? []) {
            if (material.type === 'cargo-material') {
                result.add('weight');
                result.add('loadingMeter');
                continue;
            }

            if (material.unitType === 'kilogram' || material.unitType === 'ton') {
                result.add('weight');
            } else if (material.unitType === 'liter') {
                result.add('liter');
            } else if (material.unitType === 'cubic-meter') {
                result.add('cubicMeter');
            }
        }
    }

    return result;
};
